import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "../../components/pagetitle";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import { GET_MENUS_ALL_NESTED } from "../../constant/constants";
import Executive from "../../components/Executive";

const ExecutivePage = () => {
  const [profileId, setProfileId] = useState();

  useEffect(() => {
    fetch(`${GET_MENUS_ALL_NESTED}`)
      .then((response) => response.json())
      .then((data) => {
        data.menus.find((e) =>
          e.name === "Executive Committee" ? setProfileId(e.id) : null
        );
      })
      .catch(() => {});
  }, []);
  console.log("Executive Committee", profileId);

  return (
    <Fragment>
      <PageTitle
        pageTitle={"Our Executive Committee"}
        pagesub={"Executive Committee"}
      />
      <Executive id={profileId} />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ExecutivePage;
